import { styled } from '@mui/system';
import Button from '@mui/material/Button';

const FilledButton = styled(Button)({
    background: 'linear-gradient(to right, #7c3aed, #8b5cf6, #d53f8c)', // votre dégradé
    color: 'white',
});

export { FilledButton };